"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SearchInput = require("./SearchInput");

var _SearchInput2 = _interopRequireDefault(_SearchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// eslint-disable-next-line require-await
var rehydrator = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(domNode) {
    var readData, props;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-" + prop);

              return data ? JSON.parse(data) : null;
            };

            props = {
              autoFocus: readData("auto-focus"),
              colorTheme: readData("color-theme"),
              name: readData("name"),
              placeholder: readData("placeholder"),
              typeahead: readData("typeahead"),
              typeaheadUrl: readData("typeahead-url"),
              value: readData("value")
            };
            return _context.abrupt("return", _react2.default.createElement(_SearchInput2.default, props));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function rehydrator(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = rehydrator;